const ASSETS_DIRECTORY = '.assets'
const LUZZLE_DIRECTORY = '.luzzle'
const LUZZLE_SCHEMAS_DIRECTORY = 'schemas'
const LUZZLE_PIECE_FILE_EXTENSION = 'md'

export {
	ASSETS_DIRECTORY,
	LUZZLE_DIRECTORY,
	LUZZLE_SCHEMAS_DIRECTORY,
	LUZZLE_PIECE_FILE_EXTENSION,
}
